import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withApollo, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import ButtonsView from './ButtonsView';
import CloseClaimModal from '../../../modals/CloseClaimModal';
import { CheckDocuments } from '../../../../mutations/CheckDocuments';
import * as messageActions from '../../../../actions/message-actions';
import RedirectWithFilters from '../../../RedirectWithFilters';

class ButtonsBlock extends Component {
  state = {
    redirect: false
  };

  handleClaimClosed = () => {
    this.props.actions.showMessage({
      header: 'Success',
      text: 'Claim closed',
      props: { success: true },
      duration: 2000
    });
    this.setState({ redirect: true });
  };
  handleAddTask = () => this.props.history.push('/task/new-predefined');

  handleEdit = () => this.props.history.push(`/claim/edit/${this.props.id}`);

  handleManageDocuments = () =>
    this.props.history.push(`/claim/${this.props.id}/documents`);

  handleGenerateLoa = () => {
    const {
      onClaimUpdated,
      hideLoading,
      showLoading,
      client,
      match
    } = this.props;
    showLoading();
    client
      .mutate({
        mutation: CheckDocuments,
        variables: {
          input: {
            claimId: match.params.id
          }
        }
      })
      .then(() => {
        hideLoading();
        onClaimUpdated();
      })
      .catch(() => hideLoading());
  };

  handleCheckWaiver = () => {
    const {
      onClaimUpdated,
      hideLoading,
      showLoading,
      client,
      match
    } = this.props;
    showLoading();
    client
      .mutate({
        mutation: CheckDocuments,
        variables: {
          input: {
            claimId: match.params.id,
            checkWaiver: true
          }
        }
      })
      .then(() => {
        hideLoading();
        onClaimUpdated();
      })
      .catch(error => hideLoading());
  };

  hideCloseClaimModal = () => this.setState({ closeModalOpen: false });

  showCloseClaimModal = () => this.setState({ closeModalOpen: true });

  render() {
    const { closeModalOpen, redirect } = this.state;
    const { id, crmState } = this.props;
    if (redirect) {
      return <RedirectWithFilters to={'claims'} />;
    }
    return (
      <Fragment>
        <CloseClaimModal
          open={closeModalOpen}
          claimId={id}
          crmState={crmState}
          dimmer={true}
          hideModal={this.hideCloseClaimModal}
          onClaimClosed={this.handleClaimClosed}
        />
        <ButtonsView
          showCloseClaimModal={this.showCloseClaimModal}
          onAddTask={this.handleAddTask}
          onEdit={this.handleEdit}
          onManageDocuments={this.handleManageDocuments}
          onGenerateLoa={this.handleGenerateLoa}
          onCheckWaiver={this.handleCheckWaiver}
          {...this.props}
        />
      </Fragment>
    );
  }
}

export default compose(
  withRouter,
  withApollo,
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(messageActions, dispatch)
    })
  )
)(ButtonsBlock);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/ButtonsBlock/index.js